import type { DataBindingComponentModel } from '@wix/data-binding-registry-sdk'
import { FieldType } from '@wix/wix-data-schema-types'

export const dashboardButton: DataBindingComponentModel = {
  panel: {
    height: 576,
    title: 'dsgnsys_DashboardButton_dataBinding_panelTitle',
    helpId: '00b10683-7f14-4ee3-8691-57929bf2e4b5',
  },
  isConnectGfppEnabled: true,
  sections: [
    {
      role: 'DashboardButtonRole',
      bindings: [
        {
          title: 'dsgnsys_DashboardButton_dataBinding_label_label',
          prop: 'label',
          supportedFieldTypes: [
            FieldType.text,
            FieldType.richText,
            FieldType.email,
          ],
          defaultFieldType: FieldType.text,
        },
        {
          title: 'dsgnsys_DashboardButton_dataBinding_link_label',
          prop: 'link',
          supportedFieldTypes: [FieldType.url],
          defaultFieldType: FieldType.url,
        },
      ],
    },
  ],
  compactErrorPanel: true,
}
